export var isCypress = function () {
    var _a, _b;
    var isServer = typeof window === "undefined";
    if (!isServer) {
        var isCypress_1 = (_b = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) === null || _b === void 0 ? void 0 : _b.includes("LululemonTestAutomation");
        if (isCypress_1)
            return true;
    }
    return false;
};
